module.exports = __webpack_public_path__ + "img/Technology_img2.f69dae70.jpg";